// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
// En árabe, «OTA» = «المنصة / منصات الحجز», como en la tarjeta «Comisiones de las OTAs».
export const otaNet = {
  title: "ما يصلك",
  gross: "إجمالي الحجز",
  grossOnChannel: "إجمالي الحجز على {channel}",
  grossOfUnit: "إجمالي {unit}",
  commission: "عمولة ورسوم {channel} ({rate}%)",
  commissionOfBase: "عمولة ورسوم {channel} ({rate}% من {base})",
  commissionReal: "عمولة {channel} (أبلغت عنها القناة)",
  vat: "ضريبة القيمة المضافة على العمولة ({vat}%)",
  net: "يصلك (تقريبًا)",
  howItWorks: "كيف يُحسب",
  infoEstimate: "تقدير وفق نسب «عمولات منصات الحجز» الخاصة بمكان الإقامة. قد تحوّل المنصة مبلغًا مختلفًا قليلًا (التقريب، العروض الترويجية، رسوم الدفع).",
  infoBase: "لا تُحتسب عمولة على ضريبة السياحة ولا على مبلغ التأمين.",
  infoReal: "أبلغت {channel} عن عمولة هذا الحجز. أما ضريبة القيمة المضافة على العمولة فهي تقدير وفق النسبة الواردة في «عمولات منصات الحجز»، لذا يبقى ما يصلك تقريبيًا.",
  infoRealNoVat: "أبلغت {channel} عن عمولة هذا الحجز. ومع ذلك قد يختلف المبلغ المحوَّل قليلًا (التقريب، رسوم الدفع).",
  airbnbNet: "تدفع لك Airbnb المبلغ صافيًا: ما تراه هو ما يصلك.",
  apart: "لا يشمل {amount} تحصّلها بشكل منفصل: هذا المبلغ لا يمرّ عبر {channel}.",
  theChannel: "المنصة",
};
